import React, { FC } from 'react'

import Card from '@dashboard/components/Card'
import CardHeader from '@dashboard/components/CardHeader'
import CircumplexGraph from '@dashboard/components/CircumplexGraph'
import Button from '@dashboard/components/Button'
import classNamesBind from 'classnames/bind'

import { Profile as FullProfile } from '@dashboard/lib/types'
import PaywalledContent from '@dashboard/components/PaywalledContent'

import css from './styles.module.scss'
const classNames = classNamesBind.bind(css)

interface OwnProps {
  profiles: Array<FullProfile>
  overview: string
  showPaywall?: boolean
}

const CircumplexGraphModule: FC<OwnProps> = ({
  profiles,
  overview,
  showPaywall,
}: OwnProps) => {
  // Partials
  const renderPaywall = () => {
    return (
      <Card noPadding>
        <CardHeader icon={'graph'} title="DISC" discType="empty" />
        <PaywalledContent
          wallContent="to learn about your disc type"
          paywallButtonLink="/app/register?public_assessment"
          paywallButtonText="See full profile"
          blurHeight={175}
        >
          <div className={classNames('testwrapper')}>
            <CircumplexGraph profiles={[] as FullProfile[]} size={300} />
            <div className={classNames('marginTop')}>
              <div className={classNames('header')}>
                Type:{' '}
                <span className={classNames('empty')}>
                  Your Archetype (Type)
                </span>
              </div>
              <div className={classNames('info')}>
                Your overview sentence here.
              </div>
              <Button noMargin>Sign Up Free</Button>
            </div>
          </div>
        </PaywalledContent>
      </Card>
    )
  }

  const fullProfile = profiles[0]
  let discType = 'empty'
  let archetype = 'empty'

  if (fullProfile && fullProfile.personality) {
    discType = fullProfile.personality.disc_type
    archetype = fullProfile.personality.archetype || ''
  }

  if (showPaywall) return renderPaywall()
  else if (profiles.length === 0) return null

  return (
    <Card noPadding>
      <CardHeader icon={'graph'} title="DISC" discType={discType} />
      <div className={classNames('testwrapper')}>
        <CircumplexGraph profiles={profiles} size={300} />
        <div className={classNames('marginTop')}>
          <div className={classNames('header')}>
            Type:{' '}
            <span className={classNames(discType)}>
              {archetype} ({discType})
            </span>
          </div>
          <div className={classNames('info')}>{overview}</div>
          <Button noMargin href={`/app/register?profile_id=${fullProfile.id}`}>
            Sign Up Free
          </Button>
        </div>
      </div>
    </Card>
  )
}

export default CircumplexGraphModule
